import { render, staticRenderFns } from "./NewCreateGestaoDeCAEE.vue?vue&type=template&id=15b903e8"
import script from "./NewCreateGestaoDeCAEE.vue?vue&type=script&lang=js"
export * from "./NewCreateGestaoDeCAEE.vue?vue&type=script&lang=js"
import style0 from "./NewCreateGestaoDeCAEE.vue?vue&type=style&index=0&id=15b903e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports